import createReactComponent from '../createReactComponent';
export default createReactComponent('dots-circle', 'DotsCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-9 .25v-.5m4 .5v-.5m-8 .5v-.5","key":"svg-0"}]]);